import { DASHBOARD } from "../lib/constants/actions";
export const dashboard = (state = {}, action) => {
    switch (action.type) {
        case DASHBOARD.GET_ANALYTICS_SUCCESS:
            return { ...state, analytics: action.payload }
        case DASHBOARD.GET_GOOGLE_ANALYTICS_SUCCESS:
            return { ...state, googleAnalytics: action.payload }
        case DASHBOARD.GET_GOOGLE_ANALYTICS_GRAPH_SUCCESS:
            return { ...state, googleAnalyticsGraph: action.payload }
        case DASHBOARD.GET_TOP_SEARCHES_SUCCESS:
            return { ...state, posts: action.payload }
        case DASHBOARD.GET_CAMPAIGNS_ANALYTICS_SUCCESS:
            return { ...state, campaignAnalytics: action.payload }
        case DASHBOARD.GET_TRANSACTIONS_GRAPH_DATA_SUCCESS:
            return { ...state, transactionGraphData: action.payload }

        case DASHBOARD.GET_ACTIVE_CAMPAIGNS_MAP_DATA_SUCCESS:
            return { ...state, activeCampaignsMap: action.payload }
        case DASHBOARD.GET_FAILED_URLS_DATA_SUCCESS:
            return { ...state, failedUrlData: action.payload }
        case DASHBOARD.SAVE_DASHBOARD_WIDGET_SUCCESS:
            return { ...state, widgetSaved: action.payload }
        default:
            return state;
    }
};




